module.exports = __webpack_public_path__ + "img/group_avatar_guarantee_4.37e18a40.png";